/**
 * Single source of truth for the height of input-like controls
 * (Input, TextField addon variant, SelectField, ComboboxField).
 * Keep these in sync by importing the class, never hardcoding it.
 */
export const CONTROL_HEIGHT_CLASS = `h-[50px]`
